import { NextWebVitalsMetric } from 'next/app';
import { trackNonInteractiveEvent } from './clientStatistics';
import { getSample } from './sample';

const FORCE_PERFORMANCE_EVENTS = 'forcePerformanceEvents';
const isBrowser = typeof window !== 'undefined';
let forceEvents = false;

if (isBrowser) {
    try {
        forceEvents = Boolean(JSON.parse(window.localStorage.getItem(FORCE_PERFORMANCE_EVENTS)) || false);
    } catch (e) {
        forceEvents = false;
        console.log('error reading local storage', e); // eslint-disable-line
    }
}

export function reportWebVitalsToHelix(metric: NextWebVitalsMetric): void {
    const sample = getSample();

    if (sample === 1 || forceEvents) {
        trackNonInteractiveEvent({
            name: 'performance',
            eventValues: {
                performanceId: metric.id,
                performanceName: metric.name,
                performanceLabel: metric.label,
                performanceStartTime: metric.startTime,
                performanceValue: metric.value,
            },
        });
    }
}
